/* global jQuery MicroModal */

;(function ($) {
  const wrapper = document.createElement('div')
  wrapper.setAttribute('id', 'mobile-menu')
  wrapper.setAttribute('aria-hidden', 'true')
  wrapper.setAttribute('class', 'micromodal-mobile-menu-wrapper')
  wrapper.innerHTML = `
      <div
        tabindex="-1"
        class="micromodal-mobile-menu-overlay"
        data-micromodal-close
      >
        <div
          role="dialog"
          aria-modal="true"
          aria-label="Exploring Keystone Species Menu"
          class="micromodal-mobile-menu-dialog"
        >
          <header class="micromodal-mobile-menu-header">
            <ul>
              <li><a href="index.html" class="link-home">Home</a></li>
              <li><a href="map.html" class="link-map">Map</a></li>
              <li>
                <button
                  aria-label="close modal"
                  class="micromodal-mobile-menu-close"
                  data-micromodal-close
                ></button>
              </li>
            </ul>
          </header>
          <div
            class="micromodal-mobile-menu-content"
            id="micromodal-mobile-menu-content"
          >
            <ul>
              <li>
                <a href="sea-star.html"
                  ><img
                    src="images/nav/nav-sea-star.jpg"
                    alt=""
                    role="presentation"
                  /><span>Purple Sea Star</span></a
                >
              </li>
              <li>
                <a href="beaver.html"
                  ><img
                    src="images/nav/nav-beaver.jpg"
                    alt=""
                    role="presentation"
                  /><span>Eurasian Beaver</span></a
                >
              </li>
              <li>
                <a href="vulture.html"
                  ><img
                    src="images/nav/nav-vulture.jpg"
                    alt=""
                    role="presentation"
                  /><span>Indian Vulture</span></a
                >
              </li>
              <li>
                <a href="sea-otter.html"
                  ><img
                    src="images/nav/nav-sea-otter.jpg"
                    alt=""
                    role="presentation"
                  /><span>Sea Otter</span></a
                >
              </li>
              <li>
                <a href="bass.html"
                  ><img
                    src="images/nav/nav-bass.jpg"
                    alt=""
                    role="presentation"
                  /><span>Largemouth Bass</span></a
                >
              </li>
              <li>
                <a href="crab.html"
                  ><img
                    src="images/nav/nav-crab.jpg"
                    alt=""
                    role="presentation"
                  /><span>Blue Crab</span></a
                >
              </li>
              <li>
                <a href="leopard.html"
                  ><img
                    src="images/nav/nav-leopard.jpg"
                    alt=""
                    role="presentation"
                  /><span>Leopard</span></a
                >
              </li>
              <li>
                <a href="wildebeest.html"
                  ><img
                    src="images/nav/nav-wildebeest.jpg"
                    alt=""
                    role="presentation"
                  /><span>Wildebeest</span></a
                >
              </li>
              <li>
                <a href="shark.html"
                  ><img
                    src="images/nav/nav-shark.jpg"
                    alt=""
                    role="presentation"
                  /><span>Shark</span></a
                >
              </li>
              <li>
                <a href="elephant.html"
                  ><img
                    src="images/nav/nav-elephant.jpg"
                    alt=""
                    role="presentation"
                  /><span>Elephant</span></a
                >
              </li>
              <li>
                <a href="pika.html"
                  ><img
                    src="images/nav/nav-pika.jpg"
                    alt=""
                    role="presentation"
                  /><span>Plateau Pika</span></a
                >
              </li>
              <li>
                <a href="wolf.html"
                  ><img
                    src="images/nav/nav-wolf.jpg"
                    alt=""
                    role="presentation"
                  /><span>Gray Wolf</span></a
                >
              </li>
              <li>
                <a href="flying-fox.html"
                  ><img
                    src="images/nav/nav-flying-fox.jpg"
                    alt=""
                    role="presentation"
                  /><span>Flying Fox</span></a
                >
              </li>
              <li>
                <a href="termite.html"
                  ><img
                    src="images/nav/nav-termite.jpg"
                    alt=""
                    role="presentation"
                  /><span>Mound-building Termite</span></a
                >
              </li>
              <li>
                <a href="cougar.html"
                  ><img
                    src="images/nav/nav-mountain-lion.jpg"
                    alt=""
                    role="presentation"
                  /><span>Cougar</span></a
                >
              </li>
            </ul>
          </div>
          <footer class="micromodal-mobile-menu-footer">
            <ul>
              <li><a href="supporting-information.html">Supporting Information</a></li>
              <li class="logo">
                <a href="https://www.biointeractive.org" target="_blank"
                  >HHMI BioInteractive</a
                >
              </li>
            </ul>
          </footer>
        </div>
    </div>`

  document.body.appendChild(wrapper)

  let trap = focusTrap.createFocusTrap('#mobile-menu', {
    initialFocus: false,
    escapeDeactivates: false,
    clickOutsideDeactivates: false,
    returnFocusOnDeactivate: false
  })

  let restore = null

  const trigger = document.querySelector('.trigger-menu')

  MicroModal.init({
    onShow: modal => {
      trap.activate()
      const dialog = modal.querySelector('div[role="dialog"]')
      restore = hideOthers(dialog)
    },
    onClose: modal => {
      trap.deactivate()
      restore()
      trigger.focus()
    },
    openTrigger: 'data-mobile-menu-trigger',
    awaitOpenAnimation: true,
    awaitCloseAnimation: true
  })
})(jQuery)
